import { parse as parseQuerystring } from 'querystringify';

const initialState = parseQuerystring(window.location.search);

export default function reducer(state = initialState) {
  return state;
}

export const getIsInMobileApp = (state) => 'inapp' in state.urlParams;
